import {Component, inject} from '@angular/core';
import {APP_MODAL_REF} from '../../../constants/modal/app-modal-ref.constant';
import {ModalService} from '../../../services/modal/modal.service';
import {AppDialogModal} from '../../../models/modal/dialog/app-dialog-modal.model';
import {ButtonComponent} from '../../buttons/button/button.component';
import {AppButtonTypeEnum} from '../../../enums/button/app-button-type.enum';
import {ButtonColorEnum} from '../../../enums/button/button-color.enum';
import {TranslatePipe} from '@ngx-translate/core';
import {AppDialogMessageData} from '../../../types/modal/dialog/app-dialog-message-data.type';

@Component({
    selector: 'app-dialog-modal',
    imports: [
        ButtonComponent,
        TranslatePipe
    ],
    templateUrl: './dialog-modal.component.html',
})
export class DialogModalComponent {
    public readonly modalData: AppDialogMessageData;
    protected readonly qaTag: string;
    protected readonly messageCssClass: string;
    protected readonly shouldUseFixedDialogWidth: boolean;
    protected readonly AppButtonTypeEnum = AppButtonTypeEnum;
    protected readonly ButtonColorEnum = ButtonColorEnum;
    private readonly modalRef = inject<AppDialogModal<DialogModalComponent, AppDialogMessageData, boolean>>(APP_MODAL_REF);
    private readonly modalService = inject(ModalService);

    public constructor() {
        this.qaTag = this.modalRef.qaTag;
        this.modalData = this.modalRef.modalData;
        this.shouldUseFixedDialogWidth = !this.modalData.shouldUseFluidDialogWidth;
        this.messageCssClass = this.modalData.shouldPreserveMessageFormatting ? 'modal-dialog-preformatted-message' : 'modal-dialog-message';
    }

    protected dismissWithAction(): void {
        this.modalService.closeModal(this.modalRef);
    }
}
